import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const InstructorIcon: FC<Props> = (props) => {
  const { fill, ...prop } = props;
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...prop}
     aria-label="instructor icon">
      {/* <title>instructor icon</title> */}
      <g id="vector">
        <path
          id="Vector"
          d="M5.72611 10.8605C7.10651 10.8605 8.22554 9.83471 8.22554 8.5693C8.22554 7.30389 7.10651 6.27808 5.72611 6.27808C4.34572 6.27808 3.22668 7.30389 3.22668 8.5693C3.22668 9.83471 4.34572 10.8605 5.72611 10.8605Z"
          stroke={props.fill || "currentColor" || "#747981"}
          strokeWidth="1.45259"
        />
        <path
          id="Vector_2"
          d="M10.726 15.9989C10.726 17.4234 10.726 18.5768 5.72614 18.5768C0.726318 18.5768 0.726318 17.4234 0.726318 15.9989C0.726318 14.5744 2.96525 13.421 5.72614 13.421C8.48704 13.421 10.726 14.5753 10.726 15.9989Z"
          stroke={props.fill || "currentColor" || "#747981"}
          strokeWidth="1.45259"
        />
        <path
          id="Vector_3"
          d="M13.7404 16.6551H15.2385C18.3587 16.6435 19.0627 16.5311 20.1473 15.5104C21.3665 14.3639 21.3665 12.5191 21.3665 8.82851C21.3665 5.13795 21.3665 3.29413 20.1473 2.14658C18.9281 0.999032 17.9355 1 14.0135 1C10.0915 1 8.13047 1 6.91029 2.14658C6.45845 2.58363 6.14237 3.14182 6 3.75412"
          stroke={props.fill || "currentColor" || "#747981"}
          strokeWidth="1.45259"
          strokeLinecap="round"
        />
        <path
          id="Vector_4"
          d="M14.526 13.5575H16.8501"
          stroke={props.fill || "currentColor" || "#747981"}
          strokeWidth="1.45259"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default InstructorIcon;
